import * as angular from "angular";
import {IController} from "angular";
import {Address} from "../../models/address.model";

export class AddressFormComponent implements IController {

  address: Address;
  customer: any;
  customerAddressId: any;
  isShowCustomButton: boolean;
  isCustom: boolean;
  isShowMap: boolean;
  markerPurpose: string;
  addressZoneId: string;
  isColumn: boolean;
  isZipCodeRequired: boolean = false;

  onAddressChange: Function;
  onToggleCustomAddress: Function;
  onLocationSelect: Function;
  onCustomerAddressIdSelect: Function;

  private configZoneId: string;

  /* @ngInject */
  constructor(private splitService) {
  }

  $onInit() {
    this.configZoneId = this.splitService.getTimeZone();
  }
}

angular
  .module('bringoz.admin.addresses')
  .component('addressForm', {
    bindings: {
      address: '<',
      customer: '<?',
      customerAddressId: '<?',
      isShowCustomButton: '<?',
      isCustom: '<',
      isShowMap: '<?',
      markerPurpose: '<?',
      addressZoneId: '<?',
      isColumn: '<?',
      isZipCodeRequired: '<?',
      onAddressChange: '&',
      onToggleCustomAddress: '&',
      onLocationSelect: '&?',
      onCustomerAddressIdSelect: '&?'
    },
    template: require('./address-form.html').default,
    controller: AddressFormComponent
  });
